<template>
  <div :class="CookiesoOne === 'en-US' ? 'SearchBar SearchBar-One' :'SearchBar'">
    <p
      :class="[sortField == '1' && 'active']"
      @click="checkoutSortField('1')"
    >
      {{TLang('综合','list')}}
    </p>
    <p
      :class="[sortField == '2' && 'active']"
      @click="checkoutSortField('2')"
    >
      {{TLang('销量','list')}}
    </p>
    <p
      :class="[sortField == '3' && 'active']"
      @click="checkoutSortField('3')"
    >
      {{TLang('新品','list')}}
    </p>
    <p
      :class="[sortField == '5' && 'active']"
      @click="checkoutSortField('5')"
    >
      {{TLang('热度','list')}}
    </p>
    <p
      :class="[ 'price',sortField == '4' && 'active']"
      @click="onPriceSort"
    >
      <span>{{TLang('价格','my')}}</span>
      <i
        :class="['up', sortType == '2' && 'active']"
        @click.stop="sortType = '2';
                     sortField = '4';
                     onSortTypeChange('2');"
      ></i>
      <i
        :class="['down', sortType == '1' && 'active']"
        @click.stop="
          sortType = '1';
          sortField = '4';
          onSortTypeChange('1');
        "
      ></i>
    </p>
    <div class="input-group">
      <input
        v-model="lowerPriceLimit"
        type="number"
        :placeholder="TLang('最低价','my')"
      />
      <span style="color:#ccc">&nbsp;-&nbsp;</span>
      <input
        v-model="priceCap"
        type="number"
        :placeholder="TLang('最高价','my')"
      />
      <div class="flex confirm-btns">
        <span @click="confirmPrice">{{ TLang('确定','my') }}</span>
        <div @click="canclePrice">
          {{TLang('清空','list')}}
        </div>
      </div>
    </div>
    <div class="search">
      <span
      v-if="!noStockGrayStatus"
        :class="['sort-tab-stock', !containsNoStock ? 'stockChoosed' : 'stockUnChoosed']"
        @click="checkStock"
      >{{TLang('仅看有货','list')}}</span>
      <input
        v-model="words"
        type="text"
        class="keyword-input"
      />
      <div
        class="search-btn"
        @click="confirmSearch"
      >
        {{TLang('搜索','my')}}
      </div>
    </div>
  </div>
</template>

<script>
import { getQueryString, gioClickHandle } from '@utils';
import Cookies from "js-cookie";
export default {
  props: {
    onSortFieldChange: Function,
    onSortTypeChange: Function,
    onPriceChange: Function,
    onKeyWordChange: Function,
    onStockChange: Function,
    total: Number || Object,
    noStockGrayStatus: Boolean,
    // wordsName: String,
  },
  // 排序类型 1.综合 2.销量 3.新品 4.价格 5.热度
  data() {
    return {
      channel:getQueryString('channelId') || 2,
      sortField: getQueryString('sortField') || 1,
      sortType: null,
      lowerPriceLimit: getQueryString('lp'),
      priceCap: getQueryString('hp'),
      words: getQueryString('keyword'),
      containsNoStock: getQueryString('stock') == 'false' ? false : true || true,
      CookiesoOne:Cookies.get('df_lang')
    };
  },
  watch: {
    words: function(a){
      this.words = a;
    },
  },
  methods: {
    checkoutSortField(sortField) {
      this.sortField = sortField;
      this.sortType = null;
      this.onSortFieldChange(sortField);
    },
    confirmPrice() {
      const lower = this.lowerPriceLimit === '' ? 0 : parseFloat(this.lowerPriceLimit);
      const priceCap = this.priceCap === '' ? 0 : parseFloat(this.priceCap);
      if(lower >= 0 && priceCap > 0 && lower > priceCap){
        this.$message({ type: 'error', message: this.TLang('最低价不能大于最高价','list') });
      } else {
        this.onPriceChange({
          lowerPriceLimit: this.lowerPriceLimit,
          priceCap: this.priceCap,
        });
        this.$router.push({
          path: '/product/JDList',
          query: {
            ...this.$route.query,
            lp: this.lowerPriceLimit,
            hp: this.priceCap,
          },
        });
      }
    },
    canclePrice() {
      this.lowerPriceLimit = null;
      this.priceCap = null;
      this.onPriceChange({
        lowerPriceLimit: null,
        priceCap: null,
      });
      this.$router.push({
        path: '/product/JDList',
        query: {
          ...this.$route.query,
          lp: null,
          hp: null,
        },
      });
    },
    confirmSearch() {
      this.onKeyWordChange(this.words);
      this.$router.push({
        path: '/product/JDList',
        query: {
          ...this.$route.query,
          keyword: this.words,
        },
      });
    },
    checkStock() {
      const params = {
        df_channle: '京东优选',
        df_pagename:'分类商品列表页',
        df_modulename: '筛选',
        df_elementname: '仅看有货',
      };
      if(params.df_channle){
        gioClickHandle('DF_elementClick',params,'channelGio');
      }
      setTimeout(() => {
        this.containsNoStock = !this.containsNoStock;
        this.onStockChange(this.containsNoStock);
        this.$router.push({
          path: '/product/JDList',
          query: {
            ...this.$route.query,
            stock: this.containsNoStock,
          },
        });
      }, 500);
    },
    onPriceSort(){
      if(this.sortType === '2'){
        this.sortType = '1';
        this.sortField = '4';
        this.onSortTypeChange('1');
      }else if (this.sortType === '1'){
        this.sortType = '2';
        this.sortField = '4';
        this.onSortTypeChange('2');
      }else {
        this.sortType = '2';
        this.sortField = '4';
        this.onSortTypeChange('2');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.SearchBar {
  height: 48px;
  background: rgba(247, 247, 247, 1);
  border: 1px solid rgba(229, 229, 229, 1);
  line-height: 48px;
  display: flex;
  p {
    width: 64px;
    text-align: center;
    color: #333333;
    cursor: pointer;
  }
  p.active {
    background: #fff;
    color: #4679A3;
  }
  .price {
    position: relative;
    margin-right: 12px;
    padding-right: 12px;
    i {
      position: absolute;
      border: 5px solid transparent;
      right: 15px;
    }
    .up {
      border-bottom-color: #ccc;
      top: 13px;
    }
    .down {
      border-bottom-color: #ccc;
      top: 25px;
      transform: rotate(180deg);
    }
    i.active {
      border-bottom-color: #4679A3;
    }
  }

  .search {
    margin-left: auto;
    display: flex;
    align-items: center;
    .search-btn {
      width: 44px;
      height: 28px;
      border: 1px solid rgba(229, 229, 229, 1);
      color: #111;
      text-align: center;
      line-height: 28px;
      margin-left: 5px;
      margin-right: 24px;
      &:hover {
        cursor: pointer;
      }
    }
    .count {
      font-size: 12px;
      color: rgba(153, 153, 153, 1);
      margin-right: 24px;
    }
  }
  .input-group{
    width: 300px;
    display: flex;
    align-items: center;
    input[type="number"] {
      width: 64px;
      outline: none;
      &:focus {
        border: 1px solid #4679A3;
      }
    }
    input[type="text"] {
      width: 130px;
      height: 28px;
    }

    .confirm-btns {
      margin-left: 12px;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      display: none;
      span {
        width: 39px;
        height: 24px;
        background: #4679A3;
        color: #fff;
        border-radius: 2px;
      }
      div {
        width: 39px;
        height: 22px;
        background: #fff;
        color: #999999;
        border-radius: 2px;
        border: 1px solid rgba(224, 230, 237, 1);
        margin-left: 10px;
        line-height: 22px;
      }
      &:hover {
        cursor: pointer;
      }
    }
    &:hover {
      cursor: pointer;
      .confirm-btns{
        display: flex;
      }
    }
  }
  .sort-tab-stock {
    font-size: 12px;
    color: #666;
    margin-right: 32px;
    background: url(../../../../assets/images/stock-unChoose.png) left center no-repeat;
    background-size: 14px auto;
    padding-left: 22px;
    cursor: pointer;
  }
  .stockChoosed {
    background: url(../../../../assets/images/stock-choosed.png) left center no-repeat;
    background-size: 14px auto;
  }
}
.SearchBar-One p:nth-child(2){
     line-height: 25px!important;
}
.SearchBar-One p:nth-child(3){
     line-height: 25px!important;
}
</style>
